import * as rd from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { licenseSlice } from '..'

export const beachLocationSelector = createSelector(
  [licenseSlice.selectors.licenseRemoteData],
  (data): string | null => {
    if (rd.isSuccess(data)) {
      const city = data.value.license.beach.city
      const stateName =
        data.value.license.beach.stateModel?.name ??
        data.value.license.beach.state
      return stateName.length === 0 || city === stateName
        ? city
        : `${city}, ${stateName}`
    }
    return null
  }
)
